import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useVerifyPaymentMutation } from '../../api/payment.api';
import { toast } from 'react-toastify';
import LoadingComponent from '../../common/Loading/Loading.component';
import SEO from '../../common/SEO/SEO';

const PaymentResult = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [verifyPayment] = useVerifyPaymentMutation();
    const [status, setStatus] = useState('verifying'); // verifying, success, failure

    useEffect(() => {
        const data = searchParams.get('data');
        if (data) {
            handleVerification(data);
        } else {
            setStatus('failure');
            toast.error("Payment data missing");
        }
    }, [searchParams]);

    const handleVerification = async (data) => {
        try {
            await verifyPayment(data).unwrap();
            setStatus('success');
            toast.success("Payment successful!");
            setTimeout(() => navigate('/my_account'), 3000);
        } catch (error) {
            console.error("Verification failed:", error);
            setStatus('failure');
            toast.error(error?.data?.message || "Payment verification failed");
        }
    };

    return (
        <div className="container" style={{ textAlign: 'center', padding: '100px 20px' }}>
            <SEO title="Payment Status" noindex={true} />
            {status === 'verifying' && (
                <>
                    <LoadingComponent />
                    <h2>Verifying your payment...</h2>
                    <p>Please do not refresh the page.</p>
                </>
            )}
            {status === 'success' && (
                <div style={{ color: '#27ae60' }}>
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <h2 style={{ marginTop: '20px' }}>Payment Successful!</h2>
                    <p>Your order has been placed. Redirecting to your account...</p>
                </div>
            )}
            {status === 'failure' && (
                <div style={{ color: '#e74c3c' }}>
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                    <h2 style={{ marginTop: '20px' }}>Payment Failed</h2>
                    <p>There was an issue processing your payment. Please try again.</p>
                    <button 
                        onClick={() => navigate('/check_out')}
                        className="promo_apply_btn"
                        style={{ marginTop: '20px' }}
                    >
                        Return to Checkout
                    </button>
                </div>
            )}
        </div>
    );
};

export default PaymentResult;
